"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityFinalNegotiation = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const insurer_entity_1 = require("./insurer.entity");
const look_up_entity_1 = require("./look-up.entity");
const meeting_entity_1 = require("./meeting.entity");
const opportunity_final_negotiation_qcr_variation_entity_1 = require("./opportunity-final-negotiation-qcr-variation.entity");
const opportunity_final_negotiation_service_level_agreement_entity_1 = require("./opportunity-final-negotiation-service-level-agreement.entity");
const opportunity_final_negotiation_sharing_detail_entity_1 = require("./opportunity-final-negotiation-sharing-detail.entity");
const opportunity_final_negotiation_tax_map_entity_1 = require("./opportunity-final-negotiation-tax-map.entity");
const opportunity_quote_entry_entity_1 = require("./opportunity-quote-entry.entity");
const opportunity_final_negotiation_quote_documents_entity_1 = require("./opportunity-final-negotiation-quote-documents.entity");
const opportunity_final_negotiation_quote_cover_detail_entity_1 = require("./opportunity-final-negotiation-quote-cover-detail.entity");
let OpportunityFinalNegotiation = class OpportunityFinalNegotiation {
};
exports.OpportunityFinalNegotiation = OpportunityFinalNegotiation;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "meetingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "is_final_negotiation_lid", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "isFinalNegotiationTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "select_meeting_id", type: "integer", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "selectMeeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_placed_type_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "policyPlacedTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_insurer_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "leadInsurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "is_lead_insurer_pay_commission_lid",
        type: "int",
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "isLeadInsurerPayCommissionLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "finalized_version_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "finalizedVersionId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "finalized_quote_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "finalizedQuoteId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_insurer_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "insurerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "is_quote_edited", type: "int", default: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "isQuoteEdited", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_received_on", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityFinalNegotiation.prototype, "quoteReceivedOn", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "basic_premium", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "basicPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "terrorism", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "terrorism", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "net_premium", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "netPremium", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "brokerage_percentage", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "insurerRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "other_insurer_comments", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "otherInsurerComments", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "min_of_meeting", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "mom", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiation.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityFinalNegotiation.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityFinalNegotiation.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Object)
], OpportunityFinalNegotiation.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => meeting_entity_1.Meeting),
    (0, typeorm_1.JoinColumn)({ name: "meeting_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], OpportunityFinalNegotiation.prototype, "meeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "policy_placed_type_lid" }),
    tslib_1.__metadata("design:type", typeof (_e = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _e : Object)
], OpportunityFinalNegotiation.prototype, "policyPlacedType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "is_final_negotiation_lid" }),
    tslib_1.__metadata("design:type", typeof (_f = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _f : Object)
], OpportunityFinalNegotiation.prototype, "isFinalNegotiation", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", typeof (_g = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _g : Object)
], OpportunityFinalNegotiation.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => insurer_entity_1.Insurer),
    (0, typeorm_1.JoinColumn)({ name: "lead_insurer_id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _h : Object)
], OpportunityFinalNegotiation.prototype, "leadInsurer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_quote_entry_entity_1.OpportunityQuoteEntry),
    (0, typeorm_1.JoinColumn)({ name: "finalized_quote_id" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _j : Object)
], OpportunityFinalNegotiation.prototype, "finalizedQuote", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_final_negotiation_sharing_detail_entity_1.OpportunityFinalNegotiationSharingDetail, (d) => d.finalNegotiation, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityFinalNegotiation.prototype, "sharingDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_final_negotiation_qcr_variation_entity_1.OpportunityFinalNegotiationQcrVariation, (v) => v.finalNegotiation, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityFinalNegotiation.prototype, "qcrVariations", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_final_negotiation_service_level_agreement_entity_1.OpportunityFinalNegotiationServiceLevelAgreement, (s) => s.finalNegotiation, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityFinalNegotiation.prototype, "slaDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_final_negotiation_tax_map_entity_1.OpportunityFinalNegotiationTaxMap, (t) => t.finalNegotiation, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityFinalNegotiation.prototype, "taxDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_final_negotiation_quote_documents_entity_1.OpportunityFinalNegotiationQuoteDocuments, (qd) => qd.finalNegotiation, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityFinalNegotiation.prototype, "quoteDocs", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_final_negotiation_quote_cover_detail_entity_1.OpportunityFinalNegotiationQuoteCoverDetail, (qc) => qc.finalNegotiation, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], OpportunityFinalNegotiation.prototype, "quoteCovers", void 0);
exports.OpportunityFinalNegotiation = OpportunityFinalNegotiation = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_final_negotiation")
], OpportunityFinalNegotiation);
